import Lottie from 'react-lottie'
import React, { useEffect, useState } from 'react'
import classNames from 'classnames'

export type ActiveSpeakerProps = {
  animationData: Record<any, any>
  className?: string
  width: number
  height: number
  isSpeaking?: boolean
  autoPlay?: boolean
}

export const ActiveSpeakerSignal: React.FC<ActiveSpeakerProps> = ({ animationData, width, height, className, autoPlay = true, isSpeaking }) => {
  const [isStopped, setIsStopped] = useState(false)

  useEffect(() => {
    setIsStopped(!isSpeaking)
  }, [isSpeaking])

  const defaultOptions = {
    loop: true,
    autoplay: autoPlay,
    animationData: animationData,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice',
    },
  }

  return (
    <div className={classNames('participant__participant-speaker-signal', className)}>
      <Lottie options={defaultOptions} width={width} height={height} isStopped={isStopped} isClickToPauseDisabled={true} />
    </div>
  )
}
